/// <reference path="../types/index.d.ts" />

import '../client_forms/tcadestwed/style.css';
import FormStructure from './tcadestwed/form_structure';

export default FormStructure;